/* unplugin-vue-components disabled */import script from "./studentMes_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./studentMes_copy.vue?vue&type=script&setup=true&lang=js"

import "./studentMes_copy.vue?vue&type=style&index=0&id=4da3ffd8&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da3ffd8"]])

export default __exports__